export default __webpack_public_path__ + "static/media/alamo-material-3.17707f13.webp";